var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#97B7EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04762 11.25C6.04762 11.8023 6.47401 12.25 7 12.25C7.52599 12.25 7.95238 11.8023 7.95238 11.25V8H11.0476C11.5736 8 12 7.55228 12 7C12 6.44772 11.5736 6 11.0476 6H7.95238V2.75C7.95238 2.19771 7.52599 1.75 7 1.75C6.47401 1.75 6.04762 2.19771 6.04762 2.75V6H2.95238C2.4264 6 2 6.44772 2 7C2 7.55228 2.4264 8 2.95238 8H6.04762V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/newIcon.5a531726336ce92709f1cb66b31a8eef.svg";
export { ForwardRef as ReactComponent };